import { CSSProperties, memo } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import type { SxProps, Theme } from '@mui/material';

const styles = {
  container: {
    position: 'sticky' as const,
    bottom: '1px',
    backgroundColor: 'white',
    height: '60px'
  }
};

type Props = {
  acceptButtonTitle?: string;
  cancelButtonTitle?: string;
  displayAcceptButton?: boolean;
  displayCancelButton?: boolean;
  isAcceptButtonDisabled?: boolean;
  isCancelButtonDisabled?: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
  justifyContentProp?: string;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
  disableSticky?: boolean;
  size?: 'small' | 'medium' | 'large';
};

function ActionsButtons({
  acceptButtonTitle,
  cancelButtonTitle,
  displayAcceptButton = true,
  displayCancelButton = true,
  isAcceptButtonDisabled,
  isCancelButtonDisabled,
  onAccept,
  onCancel,
  justifyContentProp = 'space-between',
  disableSticky = false,
  size = 'medium',
  ...styleButton
}: Props) {
  const { t } = useTranslation('global');

  const containerStyle = disableSticky
    ? { ...styleButton.style }
    : { ...styles.container, ...styleButton.style };

  return (
    <Grid
      alignItems="center"
      flexWrap="wrap"
      justifyContent={justifyContentProp}
      style={containerStyle}
      sx={styleButton.sx}
      container
    >
      {displayCancelButton && (
        <Button
          data-testid="cancel-button"
          disabled={isCancelButtonDisabled}
          onClick={onCancel}
          size={size}
          variant="outlined"
          {...styleButton}
        >
          {cancelButtonTitle || t('common.commonActions.cancel')}
        </Button>
      )}
      {displayAcceptButton && (
        <Button
          data-testid="accept-button"
          disabled={isAcceptButtonDisabled}
          onClick={onAccept}
          size={size}
          variant="contained"
          {...styleButton}
        >
          {acceptButtonTitle || t('common.commonActions.accept')}
        </Button>
      )}
    </Grid>
  );
}

export default memo(ActionsButtons);
